import { View, } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const DConline = ({ navigation, route }: any) => {
  const {
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values,
    kcolumnvalue,
    lcolumnvalue,
    PartA,
    PartB,
    total
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()

  const { loading, postdconline } = useFormsStore()

  const handlesubmit = async (signatureDataURL: any) => {
    const data = {
      completeOnline: true,
      essUserKey: intializestore.initializeData.userkey,
      entityId: personalstore.personalData?.entityId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      filingStatus: Number(values?.filingStatus) + 1,
      forYourself: values?.withholdingforyourself ? values?.withholdingforyourself : null,
      filingHeadofHousehold: values?.headofhousehold ? values?.headofhousehold : null,
      age65orover: values?.ageover65 ? values?.ageover65 : null,
      isBlind: values?.isblind ? values?.isblind : null,
      numberOfDependents: values?.noofdependents ? values?.noofdependents : null,
      spouseDependentChild: values?.widowwithdependentchild ? values?.widowwithdependentchild : null,
      spousePartnerAge65orOver: values?.domesticpartner65yearsofage ? values?.domesticpartner65yearsofage : null,
      spousePartnerIsBlind: values?.partnerisblind ? values?.partnerisblind : null,
      itemizedDeductions: values?.itemizeddeductions ? values?.itemizeddeductions : null,
      filingAmount: kcolumnvalue,
      subFilingAmountandDeductions: lcolumnvalue,
      totalFromSecAlineI: PartA,
      totalFromSecBlineM: PartB,
      totalWithholdingAllowancesLineN: total,
      additionalAmount: values?.additionalWithholdingAmount ? values?.additionalWithholdingAmount : null,
      claimingExcemptions: Number(values?.exemptfromwithholding) == 2 ? "Exempt" : "",
      stateOfDomicile: Number(values?.stateOfDomicile) == 1 ? true : false,
      stateOfDomicileName: values?.stateOfDomicileName ? values?.stateOfDomicileName : null,
      fulltimeStudent: Number(values?.fulltimeStudent) == 1 ? true : false,
      sign: signatureDataURL
    }
    const response = await postdconline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'DC Withholding Taxation'}
          />
        </View>
      </View>

      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('DCinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",
          })
        }
        onSubmit={handlesubmit}
      />

    </>
  )
}
export default DConline
